import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./About.css";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';



// Team data array
const teamData = [
  {
    id: 1,
    name: "SURANGA PALLIYAGURUGE",
    position: "FOUNDER",
    image: "./assets/people/suranga.png",
    bgColor: "red-bg"
  },
  {
    id: 2,
    name: "DR. THARAKA DIAS",
    position: "DIRECTOR",
    image: "./assets/people/tharaka.png",
    bgColor: "red-bg"
  },
  {
    id: 3,
    name: "DR. LEELANGA SENEVIRATNE",
    position: "DIRECTOR",
    image: "./assets/people/leelanga.png",
    bgColor: "red-bg"
  },

  {
    id: 4,
    name: "THARINDU MIHIRAN",
    position: "TECH LEAD",
    image: "./assets/people/tharindu.png",
    bgColor: "red-bg"
  },
  {
    id: 5,
    name: "FARSHAD NADHEEM",
    position: "IT MANAGER",
    image: "./assets/people/farshad.png",
    bgColor: "red-bg"
  },
  {
    id: 6,
    name: "IRSHAD NADHEEM",
    position: "SENIOR UI/UX DESIGNER",
    image: "./assets/people/irshad.png",
    bgColor: "red-bg"
  },

  {
    id: 7,
    name: "NUWANI NAWODYA",
    position: "PROJECT MANAGER",
    image: "./assets/people/nuwani.png",
    bgColor: "red-bg"
  },
  {
    id: 8,
    name: "BUDDIKA MADURANGA",
    position: "SOFTWARE ENGINEER",
    image: "./assets/people/buddika.png",
    bgColor: "red-bg"
  },
  {
    id: 9,
    name: "NIMESHA KULARATHNA",
    position: "HR MANAGER",
    image: "./assets/people/nimesha.png",
    bgColor: "red-bg"
  },
  {
    id: 10,
    name: "RAVINDU SANDARUWAN",
    position: "ASSOCIATE SOFTWARE ENGINEER",
    image: "./assets/people/ravindu.png",
    bgColor: "red-bg"
  },
  {
    id: 11,
    name: "DINETH DISSANAYAKE",
    position: "SOFTWARE ENGINEER",
    image: "./assets/people/dineth.png",
    bgColor: "red-bg"
  },
  {
    id: 12,
    name: "MADUSANKA MADAKUBURA",
    position: "MOBILE DEVELOPER",
    image: "./assets/people/madusanka.png",
    bgColor: "red-bg"
  },
  {
    id: 13,
    name: "WISHWA PERERA",
    position: "SOFTWARE ENGINEER",
    image: "./assets/people/wishwa.png",
    bgColor: "red-bg"
  },

  {
    id: 14,
    name: "DILSHAN JAYARATHNA",
    position: "DIGITAL MARKETING EXECUTIVE",
    image: "./assets/people/dilshan.png",
    bgColor: "red-bg"
  },

  {
    id: 15,
    name: "THARINDU BASNAYAKE",
    position: "SENIOR SOFTWARE ENGINEER",
    image: "./assets/people/tharindubasnayake.png",
    bgColor: "red-bg"
  },

  {
    id: 16,
    name: "THARUKA MAVITAGAMA",
    position: "BUSINESS ANALYST",
    image: "./assets/people/tharuka.png",
    bgColor: "red-bg"
  },
  {
    id: 17,
    name: "CHAMODA THATHSARANI",
    position: "ASSOCIATE QA ENGINEER",
    image: "./assets/people/chamoda.png",
    bgColor: "red-bg"
  },
  {
    id: 18,
    name: "CHATHURA ",
    position: " SENIOR SOFTWARE ENGINEER",
    image: "./assets/people/chathura.png",
    bgColor: "red-bg"
  },

  {
    id: 19,
    name: "ADEEB GAZZALI",
    position: "ASSOCIATE SOFTWARE ENGINEER",
    image: "./assets/people/adeeb.png",
    bgColor: "red-bg"
  },

  {
    id: 20,
    name: "OSADHA GANEWATHTHA",
    position: "ASSOCIATE SOFTWARE ENGINEER",
    image: "./assets/people/osadha.png",
    bgColor: "red-bg"
  },

  {
    id: 21,
    name: "JANITH SOYSA",
    position: "UI/UX DESIGNER",
    image: "./assets/people/janith.png",
    bgColor: "red-bg"
  },

  // {
  //   id: 22,
  //   name: "SAMEERA PESHAN",
  //   position: "OPERATIONS MANAGER",
  //   image: "./assets/people/sameera.png",
  //   bgColor: "red-bg"
  // },
  {
    id: 23,
    name: "THASHENU KULARATHNA",
    position: " DEVOPS ENGINEER",
    image: "./assets/people/thashenu.png",
    bgColor: "red-bg"
  },

  {
    id: 24,
    name: "SANUKA RATNAYAKE",
    position: "INTERN CYBER SECURITY",
    image: "./assets/people/sanuka.png",
    bgColor: "red-bg"
  },

  {
    id: 25,
    name: "KAVINDU HANSANA",
    position: "INTERN DEVOPS ENGINEER",
    image: "./assets/people/kavindu.png",
    bgColor: "red-bg"
  },

  {
    id: 26,
    name: "VINUJA METHSAN",
    position: "INTERN QUALITY ASSURANCE ",
    image: "./assets/people/vinuja.png",
    bgColor: "red-bg"
  },
  {
    id: 27,
    name: "CHANDANA PERERA",
    position: "SUPPORT STAFF",
    image: "./assets/people/chandana.png",
    bgColor: "red-bg"
  },

];
export default class About extends Component {

  // componentDidMount() {
  //   window.scrollTo(0, 0);
  // }

  constructor(props) {
    super(props);
    this.swiperRef = React.createRef();
    this.sectionRef = React.createRef();
    this.state = {
      isVisible: false,
      swiper: null
    };
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.setState({ isVisible: true });
            if (this.state.swiper) {
              this.state.swiper.autoplay.start();
            }
          } else {
            this.setState({ isVisible: false });
            if (this.state.swiper) {
              this.state.swiper.autoplay.stop();
            }
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of component is visible
    );

    if (this.sectionRef.current) {
      this.observer.observe(this.sectionRef.current);
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  onSwiper = (swiper) => {
    this.setState({ swiper });
    if (!this.state.isVisible) {
      swiper.autoplay.stop();
    }
  };

  render() {
    return (
      <div>
        <div className="home">
          <section className="hero">
            <h1 className="hero-text">
              <span className="highlight">Empowering Businesses</span> through <br />
              Innovation, Strategy & Tech
            </h1>
            <p className="subtext">
              At Ambrum, we transform ambitious ideas into digital realities <br />
              blending smart software solutions with impactful marketing to shape the future of business.
            </p>
            <Link to="/talk-to-us" className="cta-link">
              Book a free consultation ›
            </Link>
          </section>

          <section className="metrics">
            <div className="metric"><span className="number">4+</span> Years of Operation</div>
            <div className="metric"><span className="number">50+</span> World-wide Clients</div>
            <div className="metric"><span className="number">100+</span> Successful Projects</div>
            <div className="metric"><span className="number">50+</span> Employees</div>
          </section>

          <section className="story">
            <h2>The Ambrum Story</h2>
            <p>
              Ambrum was born from a shared vision. to bridge the gap between innovation and real-world impact.
              What began as a small team of tech enthusiasts and creative marketers has evolved into a powerhouse
              of digital transformation. We started with a simple belief: businesses, no matter their size,
              deserve access to cutting-edge technology and strategy to thrive in a rapidly changing world.
              From launching healthcare platforms and EV charging systems to redefining brands and driving
              digital campaigns, our journey has been one of continuous growth, purpose, and passion.
            </p>
            <p>
              Today, Ambrum stands as a trusted partner for startups, enterprises, and governments, helping them
              dream bigger, digitize smarter, and deliver more.
            </p>
          </section>

          <section className="services">
            <h2>What We Do Best</h2>
            <div className="service-grid">
              <div className="service">
                <img src="./assets/images/smart-house.gif" alt="Smart Tech" />
                <p>Smart Tech Solutions</p>
              </div>
              <div className="service">
                <img src="./assets/images/innovation.gif" alt="Sustainable Innovation" />
                <p>Sustainable Innovation</p>
              </div>
              <div className="service">
                <img src="./assets/images/advertising.gif" alt="Digital Marketing Mastery" />
                <p>Digital Marketing Mastery</p>
              </div>
              <div className="service">
                <img src="./assets/images/strategy.gif" alt="Business Focused Strategy" />
                <p>Business Focused Strategy</p>
              </div>
            </div>
          </section>

          <div className="section-divider" />




          {/* Vision & Mission */}
          <div className="vision-mission">
            <div className="vm-block">
              <h3 className="vm-title">Vision</h3>
              <p>To become the most trusted digital transformation partner for brands that dare to innovate.</p>
            </div>
            <div className="vm-block">
              <h3 className="vm-title">Mission</h3>
              <p>To empower businesses with tech-driven solutions and strategic creativity to deliver measurable impact, delight customers, and shape tomorrow’s industries.</p>
            </div>
          </div>


          <section className="why-choose">
            <h2>Why Choose Ambrum</h2>
            <div className="reasons">
              <div className="reason">
                <img src="./assets/images/multitasking.gif" alt="Smart expertise" />
                <p>Proven expertise in smart cities, e-health, EV, and event tech</p>
              </div>
              <div className="reason">
                <img src="./assets/images/team.gif" alt="Team strength" />
                <p>A passionate team of tech engineers, marketers & strategists</p>
              </div>
              <div className="reason">
                <img src="./assets/images/idea.gif" alt="Agility" />
                <p>Agile, transparent, and fully customizable solutions</p>
              </div>
              <div className="reason">
                <img src="./assets/images/growth.gif" alt="Results" />
                <p>Results-driven with a focus on impact and business growth</p>
              </div>
              <div className="reason">
                <img src="./assets/images/shield.gif" alt="Trusted" />
                <p>Trusted by startups, corporations, and government projects</p>
              </div>
            </div>
          </section>


          <section className="team">
            <h2>Meet the Minds Behind Ambrum</h2>


            <div className="container" ref={this.sectionRef}>
              <Swiper
                onSwiper={this.onSwiper}
                modules={[Autoplay]}
                slidesPerView={1}
                spaceBetween={10}
                pagination={{
                  clickable: true,
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                  waitForTransition: true,
                }}
                breakpoints={{
                  0: {    // 0px and up
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                  },
                  550: {    // 0px and up
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  768: {  // 768px and up
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  1024: { // 1024px and up
                    slidesPerView: 4,
                    spaceBetween: 40,
                  },
                  1200: { // 1200px and up
                    slidesPerView: 5,
                    spaceBetween: 50,
                  },
                }}
                className="mySwiper"
              >
                {teamData.map((member) => (
                  <SwiperSlide key={member.id}>
                    <div className={`team-card ${member.bgColor}`}>
                      <img
                        src={member.image}
                        alt={`${member.name} - ${member.position}`}
                        className="team-member-img"
                      />
                      <div className="card-content">
                        <p className="name-text m-0">{member.name}</p>
                        <p className="position-text">{member.position}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </section>




          {/* Culture & Values */}
          <section className="culture">
            <h2>Our Culture & Values</h2>
            <div className="culture-grid">
              <div className="culture-item">
                <img src="./assets/images/inno.gif" alt="Innovation" />
                <p>Innovation</p>
              </div>
              <div className="culture-item">
                <img src="./assets/images/creativity.gif" alt="Creativity" />
                <p>Creativity</p>
              </div>
              <div className="culture-item">
                <img src="./assets/images/coexistence.gif" alt="Collaboration" />
                <p>Collaboration</p>
              </div>
              <div className="culture-item">
                <img src="./assets/images/economy.gif" alt="Growth" />
                <p>Growth</p>
              </div>
            </div>
          </section>

          <ContactUsFooter />
        </div>
        <Footer />
      </div>

    );
  }
}
